import { QuantityDetailResp, QuantityReq, QuantityImportResp } from "./quantity-table.interface";
import { HttpService } from "@/core";
import { ExportResp } from "@/core/interface";

export class QuantityTableService {
  static useQuantityCreateApi() {
    const api = (contractId: string, data: QuantityReq) =>
      HttpService.axios({
        method: "POST",
        url: `/contract/${contractId}/quantities`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useQuantityDetailApi() {
    const api = (contractId: string) =>
      HttpService.axios({
        method: "GET",
        url: `/contract/${contractId}/quantities`,
      });
    return HttpService.useRequest<QuantityDetailResp>(api);
  }

  static useQuantityDetailApiV2() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: `/contract/${params.contractId}/quantitiesForSettlement`,
        params,
      });
    return HttpService.useRequest<QuantityDetailResp>(api);
  }

  static useQuantityImportApi() {
    const api = (contractId: string, url: string) =>
      HttpService.axios({
        method: "POST",
        // url: `/contract/${contractId}/import/quantities`,
        url: `/contract/import/quantities`,
        data: { url },
      });
    return HttpService.useRequest<QuantityImportResp>(api);
  }

  static useQuantityExportApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/contract/${id}/export/quantities`,
      });
    return HttpService.useRequest<ExportResp>(api, { isOutError: true });
  }
}
